import styles from './avatar.module.scss';
import MaterialAvatar from '@mui/material/Avatar';
import MaterialAvatarGroup from '@mui/material/AvatarGroup';

/* eslint-disable-next-line */
export interface AvatarProps {
  alt?: string,
  children?: any,
  // classes?: object,
  // component?: any,
  // imgProps?: object,
  // sizes?: string,
  src?: string,
  // srcSet?: string,
  sx?: any,
  variant?: 'circular' | 'rounded' | 'square',
  className?: string
}

export interface AvatarGroupProps {
  children?: any,
  // classes?: object,
  max?: number,
  // spacing?:'medium'| 'small',
  // sx?: any,
  total?: number,
  variant?: 'circular' | 'rounded' | 'square'
}

const stringAvatar = (name: any) => {
  const initials = `${name.split(' ')[0]?.[0] || ''}${name.split(' ')[1]?.[0] || ''}`;
  return { children: initials || null };
};

export function Avatar(props: AvatarProps) {
  return (
    <MaterialAvatar
      alt={props.alt}
      src={props.src}
      variant={props.variant}
      sx={props.sx}
      className={`${props.className}`}>
      {props.children}
    </MaterialAvatar>
  );
}

export function AvatarOnlyBorder(props: AvatarProps) {
  return (
    <Avatar {...props}
      className={`${styles.customAvatarOnlyBorder} ${props.className}`}
    />
  );
}

export function AvatarOnlyBorderPrimary(props: AvatarProps) {
  return (
    <Avatar {...props}
      className={`${styles.customAvatarOnlyBorderPrimary} ${props.className}`}
    />
  );
}

export function AvatarOnlyBorderSecondary(props: AvatarProps) {
  return (
    <Avatar {...props}
      className={`${styles.customAvatarOnlyBorderSecondary} ${props.className}`}
    />
  );
}

export function AvatarOnlyBorderSogelinkDarkBlue(props: AvatarProps) {
  return (
    <Avatar {...props}
      className={`${styles.customAvatarOnlyBorderSogelinkDarkBlue} ${props.className}`}
    />
  );
}

export function AvatarLetter(props: AvatarProps) {
  return (
    <Avatar {...props}
      className={`${styles.customAvatarLetter} ${props.className}`}
      {...stringAvatar(props.children)}
    />
  )
}

export function AvatarLetterGrey(props: AvatarProps) {
  return (
    <Avatar {...props}
      className={`${styles.customAvatarLetterGrey} ${props.className}`}
      {...stringAvatar(props.children)}
    />
  );
}

export function AvatarLetterWhite(props: AvatarProps) {
  return (
    <Avatar {...props}
      className={`${styles.customAvatarLetterWhite} ${props.className}`}
      {...stringAvatar(props.children)}
    />
  );
}

export function AvatarGroup(props: AvatarGroupProps) {
  return (
    <MaterialAvatarGroup
      max={props.max}
      variant={props.variant}>
      {props.children}
    </MaterialAvatarGroup>
  );
}

export default Avatar;